import type { EditorMutableState } from '../editorState';

/**
 * Start a gesture's draft. It begins as the SAME reference as the committed
 * shape, which is safe because every move REPLACES it with a pure edit of the
 * drag base (the committed shape, which cannot change mid-drag), so no clone
 * is needed.
 */
export function beginDraft(state: EditorMutableState): void {
  state.draftShape = state.shape;
}
